import { getReduxFeatureFlagName } from './helpers'

const getFeatureFlag = ({ state = {}, featureFlag }) =>
  state[getReduxFeatureFlagName(featureFlag)]

export { getFeatureFlag }
